import { Hero } from "@/components/home/Hero";
import { Marquee, Problem, Solutions } from "@/components/home/Intro";
import { Manifesto, Testimonials, Zone, FinalCta } from "@/components/home/Sections";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Problem />
      <Solutions />
      <Manifesto />
      <Testimonials />
      <Zone />
      <FinalCta />
    </div>
  );
}
